/* eslint-disable max-lines-per-function */
import ColorPicker from "../../ColorPicker.vue";

export default function ColorPickerWrapper({ value, onChange, ...restProps }) {
  const colors = [
    "#FFFFFF",
    "#000000",
    "#D50132",
    "#FA4617",
    "#FEB414",
    "#1261A9",
    "#432F92",
    "#008080",
    "#B6E4E4",
    "#C7B1EA",
    "#FDA398"
  ];

  function handleChange(selectedColor) {
    onChange(selectedColor);
  }

  return (
    <ColorPicker
      {...restProps}
      value={value}
      colors={colors}
      variant="inline"
      onChange={handleChange}
      data-testid="color-picker"
    />
  );
}
